import { useState } from 'react'
import './Banking.css'
import { KeyPad } from '../../general_assets/keypad'
import { Popup } from '../../general_assets/popup'
import rest from '../../utils/rest'

export function BankBtns({refresh}) {
    const [getValue, setValue] = useState({value: 0, weeks: 1, offset: 0, remove:0})
    const [getOpen, setOpen] = useState("none")

    function SetClosed() {
        setOpen("none")
        setValue({value: 0, weeks: 1, offset: 0, remove:0})
    }

    function SetSubmitted(type) {
        setOpen("none")
        if(getValue.value == null || (getValue.value > -0.01 && getValue.value < 0.01)) {return}

        switch(type) {
            case 'Auto':
                rest.JSONRequest('bank/cont', 'POST', getValue, {}).then(() => {
                    refresh(1000);
                })
                break;

            case 'Manual':
                // Defaults
                if(getValue.weeks == null) {setValue({...getValue, weeks: 1})}
                if(getValue.offset == null) {setValue({...getValue, offset: 0})}
                if(getValue.remove == null) {setValue({...getValue, remove: 0})}

                // Make requests
                rest.JSONRequest('bank/manual', 'POST', getValue, {}).then(() => {
                    refresh(1000);
                })
                break;
        }

        setValue({value: 0, weeks: 1, offset: 0, remove:0})
    }

    return (
    <div className='bank_btns'>
        <button className='btn1' onClick={() => {setOpen("Auto")}}> AUTO CONTRIBUTE </button>
        {getOpen == "Auto" ? <KeyPad getValue={getValue} setValue={setValue} setSubmitted={() => {SetSubmitted('Auto')}} setClosed={SetClosed} title={getOpen}/> : null}
            
        <button className='btn2' onClick={() => {setOpen("Manual")}}> MANUAL CONTRIBUTE </button>
        {getOpen == "Manual" ? <KeyPad getValue={getValue} setValue={setValue} title="Manual Contribution" setSubmitted={() => {SetSubmitted('Manual')}}  setClosed={SetClosed}>
            <h3> {`Weeks ${getValue.weeks}`} </h3>
            <input name='weeks' type='range' min="1" max="24" step="1" value={getValue.weeks}/> 
            <h3> {`Offset ${getValue.offset}`} </h3>
            <input name='offset' type='range' min="0" max="24" step="1" value={getValue.offset}/> 
            <h3> {`Remove? ${getValue.remove == 1 ? "yes" : "no"}`} </h3>
            <input name='remove' type='range' min="0" max="1" step="1" value={getValue.remove}/> 
        </KeyPad> : null}
    </div>
    )
}